<ul >
    <li *ngFor="let room of rooms">
        <h2>{{room.name}}</h2>
        <ul>
            <li *ngFor="let item of room.items" (click)="itemClick(item)">
                {{item.name}}
            </li>
        </ul>
    </li>
</ul>